import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-container',
  template: ` <ng-content /> `,
  styleUrl: './modal-container.component.scss',
})
export class ModalContainerComponent {}
